import { AxiosInstance } from "axios"
import { IdCardSubscriptionCompany } from "../../login/loginTypes"
import { ServiceResponse } from "../../../core/api/apiTypes"

export enum SelfSignUpApi {
    COMPANIES_BY_IDENTIFIER = "public-companies-by-identifier",
}

export enum CompaniesByIdentifierMode {
    MERCHANT_SIGNUP = "MERCHANT_SIGNUP",
}

type CompaniesByIdentifierParams = Readonly<{
    mode: CompaniesByIdentifierMode
    identifier: string
}>

export type CompaniesByIdentifierResponse = Readonly<{
    companies: IdCardSubscriptionCompany[]
    merchant: {
        id: number
    }
}>

export async function fetchCompaniesByIdentifier(
    params: CompaniesByIdentifierParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CompaniesByIdentifierResponse> {
    const { data } = await axios.get("/public/users/register/companies", {
        params,
        signal,
    })

    return data
}

export type ActivateUserBody = Readonly<{
    user: {
        displayName: string
        email: string
        mobileNumber?: string
        userGroup: {
            id: number
        }
        company: {
            id: number
        }
    }
    merchant: {
        id: number
    }
}>

export async function activateUser(
    request: ActivateUserBody,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post("/authenticate/activateUser", request, { signal })

    return data
}

